import Finish from "./Finish"

export default function FinishPage() {
  return (<Finish />);
}